// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8a2772a5","123":"c2838e65","153":"69cc12e9","453":"9bcdd46a","695":"ae797103","729":"c4025d5c"}[chunkId] + ".chunk.js";
};